import { noop } from '@aloft/toolkit-shared';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

const simple_select = { ...MapboxDraw.modes.simple_select, onDrag: noop };

export const drawModes = {
  ...MapboxDraw.modes,
  simple_select,
};
